module.exports = __webpack_public_path__ + "static/media/img2.fea2d88d.jpeg";